var map = {
	"./DEU.json": [
		7450,
		450
	],
	"./ENG.json": [
		1248,
		248
	],
	"./FRA.json": [
		5743,
		743
	],
	"./ITA.json": [
		4008,
		8
	],
	"./PRT.json": [
		4398,
		398
	],
	"./SPA.json": [
		8566,
		566
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8620;
module.exports = webpackAsyncContext;